export const COLUMN__IN_PROGRESS = 'in_progress';
export const COLUMN__VISITED = 'visited';
export const COLUMN__SIGNED = 'signed';
export const COLUMN__UNSIGNED = 'unsigned';

export const COLUMNS = [
  COLUMN__IN_PROGRESS,
  COLUMN__VISITED,
  COLUMN__SIGNED,
  COLUMN__UNSIGNED,
];

export const EVENTS = {
  // Received from CardActionsContainer to revert deal to its previous column/state
  // The original CardActionPayload is expected by the listener
  CARD_ACTION_CANCELLED: 'card-action-cancelled',
  // Received from CardActionsContainer when the action component performed normally
  // The original CardActionPayload is expected by the listener
  CARD_ACTION_COMPLETED: 'card-action-completed',
  // Received from a card whose visit has been cancelled
  CARD_ACTION_CANCELLED_VISIT: 'card-action-cancelled-visit',
  // Received from a card after being dropped/moved
  CARD_MOVED: 'deal-card-moved',
  // Received from a card action menu
  CARD_TO_ARCHIVE: 'deal-card-to-archive',
  // Open slide for feedback review
  CARD_TO_FEEDBACK: 'deal-card-to-feedback',
  // Received from a card action menu
  CARD_TO_IN_PROGRESS: 'deal-card-to-in_progress',
};
